import clsx from "clsx";
import { NavLink } from "react-router-dom";

export default function MobileNavigationTabs({
  navItems,
}: {
  navItems: {
    label: string;
    path: string;
    subNavItems?: { label: string; path: string }[];
  }[];
}) {
  return (
    <div className="pb-4 flex border-b border-b-black-200 gap-x-1 lg:hidden overflow-y-auto">
      {navItems.map(({ label, path, subNavItems }) => {
        if (subNavItems) {
          return (
            <>
              {subNavItems.map((subNavItem) => (
                <NavLink
                  to={`${path}/${subNavItem.path}`}
                  key={label}
                  className={({ isActive }) =>
                    clsx(
                      "flex px-4 h-10 rounded-2xl text-button-sm items-center transition-[color,background] text-nowrap ",
                      isActive
                        ? "bg-black-100 text-black-950"
                        : "hover:bg-black-100 text-black-400 hover:text-black-950",
                    )
                  }
                >
                  {subNavItem.label} {label}
                </NavLink>
              ))}
            </>
          );
        }
        return (
          <NavLink
            to={path}
            key={label}
            end
            className={({ isActive }) =>
              clsx(
                "flex px-4 h-10 rounded-2xl text-button-sm items-center transition-[color,background] text-nowrap ",
                isActive
                  ? "bg-black-100 text-black-950"
                  : "hover:bg-black-100 text-black-400 hover:text-black-950",
              )
            }
          >
            {label}
          </NavLink>
        );
      })}
    </div>
  );
}
